import { useQuery } from "react-query";
import { http } from "src/api/http";
import { PublishingRoyaltyDetail } from "./models";

export function usePublishinRoyaltiesDetails() {
  return useQuery<PublishingRoyaltyDetail[]>({
    queryKey: ["usePublishinRoyaltiesDetails"],
    queryFn: () => http(`/api/earnings/publishing-royalties/details`)
  });
}